import lodash from 'lodash';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const withDateListWrapper = (DateListInputComponent) => {
   const InnerDateListWrapper = (props) => {
      const [isTouched, setIsTouched] = useState(false);
      const [errorMessage, setErrorMessage] = useState();

      useEffect(() => {
         // Used for getting the errorMessage when NumberInput component is used as a FieldArray Field
         const nameParts = props.name.split(/\.|\[|]/).filter((s) => s);
         let errorPtr = props.errors;

         for (let i = 0; i < nameParts.length; i++) {
            const name = nameParts[i];
            if (errorPtr === undefined) {
               break;
            } else if (lodash.isObject(errorPtr)) {
               errorPtr = errorPtr[name];
            } else {
               errorPtr = undefined;
               break;
            }
         }

         if (typeof errorPtr === 'string' || typeof errorPtr === 'undefined') {
            setErrorMessage(errorPtr);
         } else if (lodash.isObject(errorPtr) && errorPtr?.id === 'Required!') {
            setErrorMessage('Please select a value from the autosuggest.');
         }
      }, [JSON.stringify(props.errors)]);

      useEffect(() => {
         const nameParts = props.name.split(/\.|\[|]/).filter((s) => s);
         let touchedPtr = props.touched;
         for (let i = 0; i < nameParts.length; i++) {
            const name = nameParts[i];
            if (touchedPtr === undefined) {
               break;
            } else if (lodash.isObject(touchedPtr) && Object.prototype.hasOwnProperty.call(touchedPtr, name)) {
               touchedPtr = touchedPtr[name];
            } else if (lodash.isArray(touchedPtr) && +name < touchedPtr.length) {
               touchedPtr = touchedPtr[name];
            } else {
               touchedPtr = undefined;
               break;
            }
         }

         let newIsTouched = false;
         if (touchedPtr !== undefined && lodash.isBoolean(touchedPtr)) {
            newIsTouched = touchedPtr;
         }
         setIsTouched(newIsTouched);
      }, [JSON.stringify(props.touched)]);


      return (
         <DateListInputComponent
            excludeDates={props.excludeDates}
            filterDate={props.filterDate}
            remove={props.remove}
            push={props.push}
            insert={props.insert}
            value={props.value}
            isDisabled={props.isDisabled}
            isTouched={isTouched}
            errorMessage={errorMessage}
         />
      );
   };

   InnerDateListWrapper.propTypes = {
      value: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
      isDisabled: PropTypes.bool,
      filterDate: PropTypes.func,
      excludeDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
      insert: PropTypes.func.isRequired,
      remove: PropTypes.func.isRequired,
      push: PropTypes.func.isRequired,
      errors: PropTypes.shape({}).isRequired,
      touched: PropTypes.shape({}).isRequired,
      name: PropTypes.string.isRequired,
   };

   InnerDateListWrapper.defaultProps = {
      value: [],
      isDisabled: false,
      filterDate: undefined,
      excludeDates: [],
   };

   return InnerDateListWrapper;
};

export default withDateListWrapper;
